<template>
  <div class="l-block__detail makeHeadline">
    <TitleSub level="h3">
      <span class="title">記事構成案を作成する</span>
      <span class="description"
        >「コンテンツ立案」で執筆するキーワードを調査し、記事構成案を作成しましょう。</span
      >
    </TitleSub>

    <div>
      <TitleSub level="h4">
        <span class="title">「TODO」タスクのキーワード</span>
        <Tooltip size="sm">
          新規コンテンツ作成タスクのステータスが「ToDo」のものが表示されます。見出し作成済みの場合は、タスクリスト画面でステータスを「進行中」に変更してください。
        </Tooltip>
      </TitleSub>
    </div>

    <div class="c-table">
      <div class="c-table__header">
        キーワード（<span :class="{ active: tasksCount > 0 }"
          >{{ tasksCount }}件</span
        >）
      </div>
      <div class="c-table__body">
        <div v-if="isLoading">
          <Loading variant="inline" />
        </div>
        <div v-else-if="tasksCount === 0">
          <Error variant="inline">
            <template slot="title">
              タスクがありません。
            </template>
            <p>
              タスクリスト > 新規コンテンツ作成タスクを登録すると表示されます。
            </p>
          </Error>
        </div>
        <template v-else>
          <ListItemKeywordMakeHeadline
            v-for="item in tasks"
            :key="item.id"
            :item="item"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import ListItemKeywordMakeHeadline from '@/components/dashboard/ListItemKeywordMakeHeadline';

export default {
  props: {
    tasks: {
      type: Array,
      required: true
    },
    tasksCount: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  components: {
    TitleSub,
    Tooltip,
    Loading,
    Error,
    ListItemKeywordMakeHeadline
  }
};
</script>
